module.exports = __webpack_public_path__ + "img/lnk-manuals.005501f6.svg";